import "./index.less";
import React from "react";
import { Button, Input, Form } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { wangwangService } from "@/services/customerServices";
import ProxyImage from "@/components/ProxyImage";
import contactServiceClick from "@/utils/contactService";
import { CNPrinterDownloadURL } from "@/config";
import { AddShopTutorial } from "@/utils/Url";

const QnHelpCenter: React.FC = React.memo(function () {
    const [form] = Form.useForm();

    const onSearch = () => {
        window.open("https://qw15p3s8hv.feishu.cn/wiki/wikcnktyZKjJw5x3Ni2CbX9gRQh", "_blank");
    };

    return (
        <div className="qn-help-center-container">
            <div className="services-line mb20 pb20">
                <span className="mr20 font-bold">联系客服：</span>
                <div className="mr30">
                    <span>旺旺：{wangwangService.name}</span>
                    <a
                        target="_blank"
                        href={wangwangService.url}
                        onClick={(e) => {
                            contactServiceClick(e, wangwangService.url);
                        }}
                    >
                        <ProxyImage src={wangwangService.icon} alt="点击这里给我发消息" title="点击这里给我发消息" />
                    </a>
                </div>

                <div>
                    <Button
                        href="https://wj.qq.com/s2/11784179/1c63/"
                        target="_blank"
                        danger
                        style={{ width: "initial" }}
                    >
                        客服投诉
                    </Button>
                </div>
            </div>
            <Form layout="inline" className="mb20" style={{ display: "flex", justifyContent: "center" }} form={form}>
                <Form.Item name="text">
                    <Input className="mr10 w300" placeholder="请输入关键词 如：申请电子面单" onPressEnter={onSearch} />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" onClick={onSearch}>
                        <SearchOutlined />
                        搜索帮助
                    </Button>
                </Form.Item>
            </Form>
            <div>
                <div className="mb50">
                    <h2 className="mb10 pb10">常见问题</h2>
                    <div className="faq-wrap">
                        <a href={AddShopTutorial} target="_blank">
                            多店铺关联
                        </a>
                        <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcncB5Ji6FahvJOStyb60ay0g" target="_blank">
                            手工添加/批量导入订单打印
                        </a>
                    </div>
                </div>
                <div className="mb50">
                    <h2 className="mb10 pb10">电子面单</h2>
                    <div className="faq-wrap">
                        <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnypvvxrZivF9LsBUHmS5Pti" target="_blank">
                            查电子面单余额
                        </a>

                        <a href={CNPrinterDownloadURL} target="_blank">
                            下载菜鸟打印组件
                        </a>
                    </div>
                </div>
                <div className="mb50">
                    <h2 className="mb10 pb10">打印机</h2>
                    <div className="faq-wrap">
                        <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnEd7bb9mUkFT7RAxxWZc5Kh" target="_blank">
                            打印快递单打印机没反应
                        </a>
                        <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcn7D6BWX7v83albP7t4Vf4Ph" target="_blank">
                            常见打印机驱动下载地址
                        </a>
                    </div>
                </div>

                <div className="mb50">
                    <h2 className="mb10 pb10">设置</h2>
                    <div className="faq-wrap">
                        <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnUXa6QubCidbGzw0WmrXpxD" target="_blank">
                            商品简称、重量设置
                        </a>
                        <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnuEYg3yoOB05SvNGRdGKJce" target="_blank">
                            快递单模板编辑
                        </a>
                        <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnWpSxhtOuBhHmpamv9JoD2b" target="_blank">
                            添加、修改发货人信息
                        </a>
                    </div>

                    <div className="faq-wrap">
                        <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnY3fmofQW3S1WyEX3j5FIFe" target="_blank">
                            淘宝子账号应用授权设置
                        </a>

                        <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnxq2q5nWX1Dt5JGVbZIuCFb" target="_blank">
                            取消店铺管理
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default QnHelpCenter;
